var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareMegamenuIconHelp = function SvgYeswareMegamenuIconHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 8,
    fill: "#E7F1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.292 8.329h-9.584c-2.875 0-4.791 1.916-4.791 4.791v5.75c0 2.875 1.916 4.792 4.791 4.792v2.041c0 .767.853 1.227 1.486.796l4.264-2.837h3.834c2.875 0 4.791-1.916 4.791-4.791v-5.75c0-2.876-1.916-4.792-4.791-4.792ZM17.5 19.992a.718.718 0 1 1 0-1.438.718.718 0 1 1 0 1.438Zm1.207-3.977c-.373.249-.488.412-.488.68v.201a.724.724 0 0 1-.719.72.724.724 0 0 1-.719-.72v-.2c0-1.113.815-1.659 1.122-1.87.354-.24.47-.402.47-.651a.875.875 0 0 0-.873-.872.875.875 0 0 0-.872.872.724.724 0 0 1-.719.718.724.724 0 0 1-.719-.718 2.31 2.31 0 0 1 4.62 0c0 1.092-.805 1.638-1.102 1.84Z",
    fill: "#039BE5"
  })));
};
export default SvgYeswareMegamenuIconHelp;